var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"player-name"},[_c('span',{staticClass:"stone",class:_vm.colour}),_c('span',{staticClass:"name",class:{ empty: !_vm.player }},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }